export default __webpack_public_path__ + "assets/images/answer-before-3350d9bf.png";